import { KeyRound, Settings } from "lucide-react";
import { Button, type ButtonProps } from "@/modern/components/ui/button";
import { useIntegrationErrorReporter } from "./useIntegrationErrorReporter";
import { INTEGRATION_FIX_LABELS } from "./constants";
import type { IntegrationProvider } from "./types";

type IntegrationFixLinkProps = {
  provider: IntegrationProvider;
  label?: string;
  className?: string;
  size?: ButtonProps["size"];
};

export const IntegrationFixLink = ({
  provider,
  label,
  className,
  size = "sm",
}: IntegrationFixLinkProps) => {
  const { canFixIntegration, openIntegrationFix } = useIntegrationErrorReporter();

  if (!canFixIntegration(provider)) return null;

  const resolvedLabel = label ?? INTEGRATION_FIX_LABELS[provider];
  const Icon = provider === "openai" ? KeyRound : Settings;
  const iconClassName = size === "xs" ? "h-3.5 w-3.5 mr-1.5" : "h-4 w-4 mr-2";

  return (
    <Button
      type="button"
      size={size}
      variant="outline"
      className={className}
      onClick={() => openIntegrationFix(provider)}
    >
      <Icon className={iconClassName} />
      {resolvedLabel}
    </Button>
  );
};

/** @deprecated Use IntegrationFixLink */
export const IntegrationSettingsLink = IntegrationFixLink;
